<template>
  <div>

     <ejs-dropdownlist
      placeholder="EMPRESA"
      :allowFiltering='allowFiltering' 
      :filtering='filteringEmpresa'
      :dataSource="users"
      :fields="selectionFields"
      v-model="company"
      class="w-full"
      v-validate="'required'"
      data-vv-validate-on="blur"
      name="company"
      data-vv-as="Empresa"
      floatLabelType="Auto"
      :select="changeCompany"
    ></ejs-dropdownlist>
    <span class="text-danger text-sm">{{ errors.first('company') }}</span>

    <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        name="user"
        data-vv-as="Ruc/Ced"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="RUC/CED"
        v-model="user"
        autocomplete="off"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('user') }}</span>

    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required'"
        type="password"
        name="password"
        data-vv-as="Contraseña"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="CONTRASEÑA"
        v-model="password"
        class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">RECUERDAME</vs-checkbox>
        <!-- <router-link to="/pages/forgot-password">Forgot Password?</router-link> -->
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button :hidden ="register" @click="registerUser">REGISTRARSE</vs-button>
      <div :hidden ="!register"></div>
      <vs-button :disabled="!validateForm" type="border" @click="loginJWT">INGRESAR</vs-button>
      
    </div>
    <vs-button class="salirbutton" type="border" @click="salir">SALIR</vs-button>
  </div>
</template>

<script>
import axios from "axios";
import auth from '@/auth/authService'
import Vue from "vue";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DataManager,Query,ODataV4Adaptor,Predicate } from "@syncfusion/ej2-data";
import {mapMutations, mapState, mapActions} from 'vuex'

Vue.use(DropDownListPlugin);

var jwt = require("jsonwebtoken");
var register = true
var params
export default {
  data () {
    return {
      allowFiltering: true,
      selectionFields: { text: "value", value: "id" },
      user: '',
      password: '',
      company: '',
      checkbox_remember_me: false,
      users: [],
      register,
      params: []
    }
  },
  computed: {
    ...mapState('eCommerce', ['empresas', 'paramsCompany']),
    validateForm () {
      return !this.errors.any() && this.company !== '' && this.user !== '' && this.password !== ''
    }
  },
  mounted: function() {
    this.loadData();
    // console.log(auth.getValidToken()==0?'s':'n')
  },
  methods: {
    ...mapActions('eCommerce', ['getEmpresas', 'getParamsCompany']),
    filteringEmpresa: function(e) {
      var query = new Query();
      query = (e.text != "") ? query.where("value", "contains", e.text, true) : query;
      e.updateData(this.users, query);
    },
    changeCompany: function(event) {
      this.getParamsCompany(event.itemData.id).then(response => {
        this.params = this.paramsCompany;
        if(this.params.ec_regcli=='S'){
          localStorage.setItem('codemp', this.company);
          this.register = false
        }else{
          this.register = true
        }
      }).catch(e => {
          this.register = true
      })
    },
    loadData: function() {
      this.getEmpresas().then(
      response => { 
        this.users = this.empresas;
      })    
    },

    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT () {

    localStorage.setItem('rucced', this.user);
    localStorage.setItem('codemp', this.company);
    // sessionStorage

      axios.post(''+auth.connectionFrontEnd()+'/webapi/loginEC',
      {
          usuario: this.user,
          password: this.password,
          codemp: this.company
        }
      ).then(response => {

            var dataControl = response.data.success;
            var valueRemember = this.checkbox_remember_me;
            if (dataControl == true) {

              if (valueRemember == false) {
                sessionStorage.setItem("ecplus", response.data.token);
              } else if (valueRemember == true) {
                localStorage.setItem("ecplus", response.data.token);
              }
              localStorage.setItem("parcli", JSON.stringify(this.params));
              localStorage.setItem("artcla", JSON.stringify(response.data.clases));

              if(this.user ===  this.password){
                this.$router.push({name: 'page-reset-password', params: {comp: this.company, user:this.user, pass:this.password, tok: response.data.token }})
                .catch(() => {})
              }else{

                this.$router.push({name: 'ecommerce-shop', params: {par: this.params }})
                .catch(() => {})
              }
              
            }       


            }).catch(e => {
              this.$vs.notify({
                  title: 'Error',
                  text: 'USUARIO NO ENCONTRADO O INFORMACIÓN INCORRECTA',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
            })
    },
    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/pages/register').catch(() => {})
    },
    salir(){
      this.$router.push('/pages/company')
    }
  }
}

</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
.salirbutton{
  width: -webkit-fill-available;
}

[dir] .e-input-group:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left), [dir] .e-input-group.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error) .e-input-in-wrap, [dir] .e-input-group.e-control-wrapper:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left), [dir] .e-input-group.e-control-wrapper.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error) .e-input-in-wrap, [dir] .e-float-input.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error) .e-input-in-wrap, [dir] .e-float-input.e-control-wrapper.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error) .e-input-in-wrap {
    border-color: rgba(0, 0, 0, 0.42);
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 0.3rem 0rem 0rem 2rem;
    height: 38.4px;
}

.e-float-input.e-control-wrapper:not(.e-error) input:focus ~ label.e-float-text, .e-float-input.e-control-wrapper:not(.e-error) input:valid ~ label.e-float-text, .e-float-input.e-control-wrapper:not(.e-error) input ~ label.e-label-top.e-float-text, .e-float-input.e-control-wrapper:not(.e-error) input[readonly] ~ label.e-label-top.e-float-text, .e-float-input.e-control-wrapper:not(.e-error) input[disabled] ~ label.e-label-top.e-float-text, .e-float-input .e-control-wrapper:not(.e-error) input label.e-float-text.e-label-top, .e-float-input.e-control-wrapper.e-bigger:not(.e-error) input:focus ~ label.e-float-text, .e-float-input.e-control-wrapper.e-bigger:not(.e-error) input:valid ~ label.e-float-text, .e-float-input.e-control-wrapper.e-bigger:not(.e-error) input ~ label.e-label-top.e-float-text, .e-float-input.e-control-wrapper.e-bigger:not(.e-error) input[readonly] ~ label.e-label-top.e-float-text, .e-float-input.e-control-wrapper.e-bigger:not(.e-error) input[disabled] ~ label.e-label-top.e-float-text, .e-bigger .e-float-input.e-control-wrapper:not(.e-error) input:focus ~ label.e-float-text, .e-bigger .e-float-input.e-control-wrapper:not(.e-error) input:valid ~ label.e-float-text, .e-bigger .e-float-input.e-control-wrapper:not(.e-error) input ~ label.e-label-top.e-float-text, .e-bigger .e-float-input.e-control-wrapper:not(.e-error) input[readonly] ~ label.e-label-top.e-float-text, .e-bigger .e-float-input.e-control-wrapper:not(.e-error) input[disabled] ~ label.e-label-top.e-float-text, .e-float-input.e-control-wrapper:not(.e-error).e-input-focus input ~ label.e-float-text, .e-float-input.e-control-wrapper.e-bigger:not(.e-error).e-input-focus input ~ label.e-float-text, .e-bigger .e-float-input.e-control-wrapper:not(.e-error).e-input-focus input ~ label.e-float-text {
    color: rgba(0, 0, 0, 0.54);
    padding-left: 3rem !important;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
    font-size: 13px;
    font-weight: 200;
    font-style: normal;
    font-size: smaller;
}

.e-ddl.e-input-group.e-control-wrapper .e-ddl-icon::before {
    content: "\E969";
    font-family: 'e-icons';
    padding-bottom: 0.7rem;
}

.e-float-input:not(.e-input-focus):not(.e-disabled) input:not(:focus):not(:valid) ~ label.e-float-text:not(.e-label-top), .e-float-input:not(.e-input-focus) textarea:not(:focus):not(:valid) ~ label.e-float-text:not(.e-label-top), .e-float-input.e-control-wrapper:not(.e-input-focus):not(.e-disabled) input:not(:focus):not(:valid) ~ label.e-float-text:not(.e-label-top) {
    color: rgba(0, 0, 0, 0.42);
    padding-left: 2.5rem;
    padding-top: 0.3rem;
}

[dir] .e-input-group.e-input-focus:not(.e-float-icon-left):not(.e-success):not(.e-warning):not(.e-error), [dir] .e-input-group.e-control-wrapper.e-input-focus:not(.e-float-icon-left):not(.e-success):not(.e-warning):not(.e-error), [dir] .e-float-input.e-input-group.e-input-focus:not(.e-float-icon-left):not(.e-success):not(.e-warning):not(.e-error), [dir] .e-float-input.e-input-group.e-input-focus:not(.e-float-icon-left).e-success:not(.e-warning):not(.e-error), [dir] .e-float-input.e-input-group.e-input-focus:not(.e-float-icon-left):not(.e-success).e-warning:not(.e-error), [dir] .e-float-input.e-input-group.e-input-focus:not(.e-float-icon-left):not(.e-success):not(.e-warning).e-error, [dir] .e-float-input.e-control-wrapper.e-input-group.e-input-focus:not(.e-float-icon-left):not(.e-success):not(.e-warning):not(.e-error), [dir] .e-float-input.e-control-wrapper.e-input-group.e-input-focus:not(.e-float-icon-left).e-success:not(.e-warning):not(.e-error), [dir] .e-float-input.e-control-wrapper.e-input-group.e-input-focus:not(.e-float-icon-left):not(.e-success).e-warning:not(.e-error), [dir] .e-float-input.e-control-wrapper.e-input-group.e-input-focus:not(.e-float-icon-left):not(.e-success):not(.e-warning).e-error, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning):not(.e-error) input, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled).e-success:not(.e-warning):not(.e-error) input, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success).e-warning:not(.e-error) input, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning).e-error input, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning):not(.e-error) textarea, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled).e-success:not(.e-warning):not(.e-error) textarea, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success).e-warning:not(.e-error) textarea, [dir] .e-float-input.e-control-wrapper.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning).e-error textarea, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning):not(.e-error) input, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled).e-success:not(.e-warning):not(.e-error) input, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success).e-warning:not(.e-error) input, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning).e-error input, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning):not(.e-error) textarea, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled).e-success:not(.e-warning):not(.e-error) textarea, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success).e-warning:not(.e-error) textarea, [dir] .e-float-input.e-input-focus:not(.e-input-group):not(.e-float-icon-left):not(.e-disabled):not(.e-success):not(.e-warning).e-error textarea, [dir] .e-input-group.e-input-focus:not(.e-float-icon-left).e-success:not(.e-warning):not(.e-error), [dir] .e-input-group.e-input-focus:not(.e-float-icon-left).e-warning:not(.e-success):not(.e-error), [dir] .e-input-group.e-control-wrapper.e-input-focus:not(.e-float-icon-left).e-success:not(.e-warning):not(.e-error), [dir] .e-input-group.e-control-wrapper.e-input-focus:not(.e-float-icon-left).e-warning:not(.e-success):not(.e-error), [dir] .e-input-group.e-input-focus:not(.e-float-icon-left).e-error:not(.e-success):not(.e-warning), [dir] .e-input-group.e-float-icon-left.e-input-focus:not(.e-success):not(.e-warning):not(.e-error) .e-input-in-wrap, [dir] .e-input-group.e-float-icon-left.e-input-focus.e-success:not(.e-warning):not(.e-error) .e-input-in-wrap, [dir] .e-input-group.e-float-icon-left.e-input-focus.e-warning:not(.e-success):not(.e-error) .e-input-in-wrap, [dir] .e-input-group.e-float-icon-left.e-input-focus.e-error:not(.e-success):not(.e-warning) .e-input-in-wrap {
    border-style: solid;
    border-width: 0 0 1px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 0.3rem 0rem 0rem 2rem;
}
</style>

